// 众惠材料经理菜单


let menuMallMaterialManager = [
    // {
    //     path:'/',
    //     component: "HomeView",
    //     redirect: '/home/IndexView',
    //     name: '首页',
    //     parent:true,
    //     children:[
    //         {
    //             pageAddress:"IndexView",
    //             path:"/home/IndexView",
    //             component:"IndexView",
    //             name:"实时数据",
    //         }
    //     ]

    // },
    {
		path:'/p0',
        redirect: '/common/complaintList',
        component: "HomeView",
        name: '营销管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"公关管理",
                children:[
                    // {
                    //     pageAddress:"commonPage/complaintManage/complaintList",
                    //     path:"/common/complaintList",
                    //     component:"complaintList",
                    //     name:"投诉管理"
                    // },	
                    {
                        pageAddress:"commonPage/complaintManage/addComplainList",
                        path:"/common/addComplainList",
                        hidden:true, 
                        component:"addComplainList",
                        name:"添加投诉"
                    },
                    {
                        pageAddress:"commonPage/complaintManage/complaintDetail",
                        path:"/common/complaintDetail",
                        hidden:true, 
                        component:"complaintDetail",
                        name:"投诉详情"
                    }
                    
                ]
            }
        ]

    },
    // {
    //     path: '/p1',
    //     component: "HomeView",
    //     name: '运营管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p2',
    //     component: "HomeView",
    //     name: '合同管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p3',
    //     component: "HomeView",
    //     name: '工程管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p4',
    //     component: "HomeView",
    //     name: '材料管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p5',
    //     component: "HomeView",
    //     name: '财务管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p6',
    //     component: "HomeView",
    //     name: '项目总监管理',
    //     disable:true,//无权限
    // },
    // {
    //     path: '/p7',
    //     component: "HomeView",
    //     name: '客户管理',
    //     disable:true,//无权限
    // },
	{
		path:'/p8',
        redirect: '/me/change_password',
        component: "HomeView",
        name: '系统管理',
        parent:true,
        children:[
            {
                parent:true,
                component:"Navigation",
                path:"/home",
                name:"个人设置",
                children:[
                    // { 
                    //     path: '/me/change_password', 
                    //     component: "ChangePasswordView", 
                    //     name: '修改密码' 
                    // },
                ]
            }
        ]

    },
];

export default menuMallMaterialManager;


// WEBPACK FOOTER //
// ./src/menu/menuMallMaterialManager.js